export default __webpack_public_path__ + "assets/step_qr_code_1.cd1078ee.svg";